import {
  setWishlistUid,
  setWishlistEntries,
  setWishlistEntriesLoading,
  unsetWishlistEntriesLoading,
  notifyProduct,
  deleteWishlistEntry,
} from '@/account/context/wishlist/action-creators';

export default dispatch => ({
  setWishlistUid: payload => dispatch(setWishlistUid(payload)),
  setWishlistEntries: payload => dispatch(setWishlistEntries(payload)),
  setWishlistEntriesLoading: () => dispatch(setWishlistEntriesLoading()),
  unsetWishlistEntriesLoading: () => dispatch(unsetWishlistEntriesLoading()),
  notifyProduct: payload => dispatch(notifyProduct(payload)),
  deleteWishlistEntry: payload => dispatch(deleteWishlistEntry(payload)),
});
